import axios from "axios";
// import { api } from "../config";

axios.defaults.baseURL = window._env_?.REACT_APP_API_URL || 'http://localhost:3000/api';
axios.defaults.headers.post["Content-Type"] = "application/json";

// Leer token desde sessionStorage
const getAuthToken = (): string | null => {
  return sessionStorage.getItem("authToken");
};

const getTokenExpiration = (): Date | null => {
  const expires = sessionStorage.getItem("authTokenExpires");
  return expires ? new Date(expires) : null;
};

const isTokenExpired = (): boolean => {
  const expires = getTokenExpiration();
  return !expires || new Date() > expires;
};

// Setear token si está presente y no expirado
const setupAuthorization = () => {
  const token = getAuthToken();
  if (token && !isTokenExpired()) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
    // Opcional: redireccionar a login o limpiar sesión
    // window.location.href = "/login";
  }
};

setupAuthorization();

// intercepting to capture errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    let message;
    const status = error.response?.status;
    switch (status) {
      case 500:
        message = "Error interno del servidor";
        break;
      case 401:
        message = "Credenciales inválidas o sesión expirada";
        break;
      case 404:
        message = "No se encontró el recurso solicitado";
        break;
      default:
        message = error.response?.data?.message || "Error desconocido";
    }
    return Promise.reject(message);
  }
);

const setAuthorization = (token: any) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url: any, params: any = {}, options: any = {}) => {
    let response;
    let paramKeys: any = [];

    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        paramKeys.push(`${key}=${params[key]}`);
        return paramKeys;
      });

      const queryString = paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, options);
    } else {
      response = axios.get(url, options);
    }

    return response;
  };

  /**
   * post given data to url
   */
  create = (url: any, data: any, config: any = {}) => {
    return axios.post(url, data, config);
  };
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: any, data: any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url: any, config: any = {}) => {
    return axios.delete(url, config);
  };
}
const getLoggedUser = () => {
  const user = sessionStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};

export { APIClient, setAuthorization, getLoggedUser, setupAuthorization, isTokenExpired };